
























































































import DossierLabels from "./../DossierLabels.js";
import Vue, { PropType } from "vue";
import { Contact } from "../../../types/dossier/data/Contact";

export default Vue.extend({
  name: "contact-view",
  props: {
    contact: {
      type: Object as PropType<Contact>,
      required: true,
    },
  },
  data() {
    return {
      labels: DossierLabels.contact,
    };
  },
});
